import IStaffOnSiteDiaryNotesModel from "interfaces/SiteDiary/StaffOnSite/IStaffOnSiteDiaryNotesModel";
import StaffOnSiteProps from "interfaces/SiteDiary/StaffOnSite/StaffOnSiteProps";
import ISiteDiaryStaffOnSite from "interfaces/SiteDiary/StaffOnSite/ISiteDiaryStaffOnSite";
import IGetSiteDiaryResponseModel from "interfaces/Response/IGetSiteDiaryResponseModel";

function mapStaffOnSiteNotes(
  staffOnSite: ISiteDiaryStaffOnSite
): IStaffOnSiteDiaryNotesModel | undefined {
  let note: IStaffOnSiteDiaryNotesModel | undefined;

  if (staffOnSite && staffOnSite.id && staffOnSite.notes) {
    note = {
      id: staffOnSite.id,
      notes: staffOnSite.notes
    };
  }

  return note;
}

function mapGetSiteDiaryResponseModelToStaffOnSiteProps(
  siteDiaryResponseModel: IGetSiteDiaryResponseModel,
  hwrcSiteId: string,
  diaryDate:string
): StaffOnSiteProps {
  const staffOnSiteProps: StaffOnSiteProps = {
    staffOnSite: [],
    hwrcSiteId,
    diaryDate,
    diarySaved: false
  };

  if (
    siteDiaryResponseModel.siteDiary
    && siteDiaryResponseModel.siteDiary.staffOnSite
  ) {
    staffOnSiteProps.staffOnSite = siteDiaryResponseModel.siteDiary.staffOnSite;
    staffOnSiteProps.staffOnSite.forEach((sOs: ISiteDiaryStaffOnSite) => {
      sOs.childData = [];
      sOs.diaryDate = diaryDate;
      sOs.hwrcSiteId = hwrcSiteId;
      const noteModel = mapStaffOnSiteNotes(sOs);

      if (noteModel) {
        sOs.childData.push(noteModel);
      }
    });
  }

  return staffOnSiteProps;
}

export { mapStaffOnSiteNotes, mapGetSiteDiaryResponseModelToStaffOnSiteProps };
